import domReady from '@wordpress/dom-ready';

/*
 * Constants
 ***************************/
 var $ = jQuery.noConflict()
 const mobileBreakpoint = parseInt(mpfVars.breakpoints.mobile_max);
 const navBreakpoint = parseInt(mpfVars.breakpoints.mobile_navigation_max);
 const windowResizeActions = [];
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

 /*
  * Viewport height adjustments
  ***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
let screenSize = window.innerWidth;
document.documentElement.style.setProperty('--screen-size', `${screenSize}`);
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
 // We execute the same script as before
 vh = window.innerHeight * 0.01;
 document.documentElement.style.setProperty('--vh', `${vh}px`);
 screenSize = window.innerWidth;
 document.documentElement.style.setProperty('--screen-size', `${screenSize}`);
});

/*
 * Globals
 ***************************/
  /* Window */
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
    let windowScrollHeight = document.querySelector('body').scrollHeight;
  /* Breakpoints */
    window.isMobile = ( windowWidth <= mobileBreakpoint );
    window.isMobileNavigationActive = ( windowWidth <= navBreakpoint );
  /* Navigation */
    let isMenuOpen = false,
        isTakeoverMenuOpen = false,
        isSearchOpen = false;

  /* Slick Options */
  import { prevArrow, nextArrow } from './util';


const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

domReady(() => {
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  const lenis = new Lenis({
    autoRaf: true,
    duration: 0.8,
    allowNestedScroll: true
  });

  // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
  lenis.on('scroll', ScrollTrigger.update);

  /* Generic */
  if ( $('a.smooth-scroller, .smooth-scroller a').length ) { // internal links, smooth scrolling
    $('a.smooth-scroller, .smooth-scroller a').on('click', function(e){
      e.preventDefault();
      const target = $(this).attr('href');
      if ( target.charAt(0) === '#' && $(target).length > 0 ) {
        gsap.to(window, {
          scrollTo: {
            y: target,
            offsetY: 100
          },
          duration: 0.8,
          ease: 'power1.inOut'
        });
      }
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */

  /* NAVIGATION SCRIPTS */
  if ( $('.site-header').length ) {
    const header = $('.site-header');
    ScrollTrigger.create({
        trigger: 'body',
        start: 'top top-=15',
        end: 'bottom top',
        onEnter: () => {
          header.addClass('scrolled').addClass('has-black-color');
        },
        onLeaveBack: () => {
          header.removeClass('scrolled').removeClass('has-black-color');
        }
    });
  }

  if ( $('.site-header__nav').length ) {
    const navResizeAction = (updated, navUpdated) => {
      if ( navUpdated ) {
        if ( isMobileNavigationActive ) {
          $('#site-nav').attr('role', 'dialog');
          $('#site-nav').attr('aria-modal', 'true');
        } else {
          const navEl = $('#site-nav').get(0);
          navEl.removeAttribute('role');
          navEl.removeAttribute('aria-modal');
        }
      }
    };

    navResizeAction(true, true);
    windowResizeActions.push(navResizeAction);

    const mobileNavContainer = $('.site-header__nav-inner');
    const mobileToggle = $('.site-header__nav-toggle');
    const mobileDismiss = $('.site-header__nav-dismiss');
    const firstFocusableMenuElement = $(mobileNavContainer).find('a, button, input').eq(0).get(0);
    const lastFocusableMenuElement = mobileDismiss.get(0);

    if ( $(mobileNavContainer).find('.menu-item-has-children') ) {
      $(mobileNavContainer).find('.menu-item-has-children').each(function(){
        const toggle = $(this).children('a, button');
        const submenu = $(this).children('.sub-menu')

        let target = $(toggle).attr('aria-controls');
        let expanded = $(toggle).attr('aria-expanded');

        const toggleResizeAction = (updated, navUpdated) => {
          if ( navUpdated ) {
            if ( isMobileNavigationActive ) {
              $(toggle).attr('aria-controls', target);
              $(toggle).attr('aria-expanded', expanded);
            } else {
              $(toggle).get(0).removeAttribute('aria-controls');
              $(toggle).get(0).removeAttribute('aria-expanded');
            }
          }
        };
        toggleResizeAction(true);

        toggle.on('click', function(){
          if ( isMobileNavigationActive ) {
            expanded = expanded == 'true' ? 'false' : 'true';
            $(toggle).attr('aria-expanded', expanded);
            submenu.slideToggle();
          }
        }).on('keypress', handleKeypressADA);
      });
    }

    $('.site-header__nav-toggle').on('click', function(){
      $(this).toggleClass('active');
      if ( $(this).hasClass('active') ) {
        $(mobileNavContainer).css({
          'visibility': 'visible',
          'pointer-events': 'auto'
        });
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          onComplete: function(){
            $(mobileNavContainer).focus();
          }
        });
      } else {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });
      }
    }).on('keypress', handleKeypressADA);

    $(mobileDismiss).on('click', function(){
      if ( isMobileNavigationActive ) {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });

        $(mobileToggle).removeClass('active');
        $(mobileToggle).focus();
      }
    }).on('keypress', handleKeypressADA);

    $(mobileNavContainer).on('keydown', function(e){
      if ( isMobileNavigationActive ) {
        if ( e.key == 'Escape' ) {
          mobileDismiss.click();
        } else if(e.target == firstFocusableMenuElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableMenuElement.focus();
        } else if(e.target == lastFocusableMenuElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableMenuElement.focus();
        }
      }
    });
  }
  /* END NAVIGATION SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  $('ul, ol').each(function(){
    if ( this.getAttribute('reversed') !== null ) {
      const items = $(this).children('li');
      $(this).css('counter-reset', 'olcounter ' + (items.length + 1));
    }

    if ( this.getAttribute('start') !== null ) {
      const start = parseInt(this.getAttribute('start'));
      $(this).css('counter-reset', 'olcounter ' + (start - 1));
    }
  });
  
  if ( $('.wp-block-video, .wp-block-embed.is-provider-youtube, .wp-block-embed.is-provider-vimeo, .header-media-container:has(.header-media-video)').length ) {
    $('.wp-block-video, .wp-block-embed.is-provider-youtube, .wp-block-embed.is-provider-vimeo, .header-media-container:has(.header-media-video)').each(function(){
      const target = $(this).find('video, .wp-block-embed__wrapper, .header-media-video-embed');
      const el = target.get(0);
      
      const controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
      const minimalControls = ['play'];
      let shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false;
      if ( $(this).hasClass('header-media-container') ) {
        shouldAutoplay = true;
      }

      const usesMinimalControls = (el.hasAttribute('controls') && el.getAttribute('controls') === 'false') || ( !el.hasAttribute('controls') && $(el).is('video') ) || ( $(this).hasClass('minimal-controls') || $(el).hasClass('minimal-controls') );
      
      const args = {
        autoplay: shouldAutoplay,
        controls: usesMinimalControls ? minimalControls : controls,
        playsinline: el.hasAttribute('playsinline') ? (el.getAttribute('playsinline') === 'true' || el.getAttribute('playsinline') === '') : false,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
        muted: shouldAutoplay ? true : ( el.hasAttribute('muted') ? (el.getAttribute('muted') === 'true' || el.getAttribute('muted') === '') : false ),
        iconUrl: mpfVars.svgSpritesheet,
        hideControls: usesMinimalControls ? false : true
      };
      
      try { 
        window.localStorage.removeItem("plyr")
      } catch (e) {
        console.error( 'Could not access localStorage to remove plyr item. This may cause issues with video playback on some browsers. Error details: ', e);
      }
      
      const player = new Plyr(el, args);
    });
  }
  
  if ( $('.wp-block-audio').length ) {
    $('.wp-block-audio').each(function() {
      const target = $(this).find('audio');
      const el = target.get(0);
      
      const controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
      const shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false;
      
      const args = {
        autoplay: shouldAutoplay,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
        iconUrl: mpfVars.svgSpritesheet,
      };
      
      const player = new Plyr(el, args);
    });
  }
  
  // dropdowns
  if ( $('.mpf-dropdown').length ) {
    $('.mpf-dropdown').each(function(){
      const container = this;
      const trigger = this.querySelector('.mpf-dropdown__toggle');
      const inner = this.querySelector('.mpf-dropdown__inner');
      const selectedText = trigger.querySelector('span');
      const optionsList = this.querySelector('.mpf-dropdown__dropdown');  
      const options = this.querySelectorAll('.mpf-dropdown__dropdown li');
      const hiddenField = this.querySelector('.mpf-dropdown__hidden-input');
      const labelEx = options;

      let isExpanded = false;

      $(optionsList).css({
        width: 'auto'
      });

      console.log(  Math.round( ($(optionsList).width() - parseInt($(labelEx).css('padding-left')) - parseInt($(labelEx).css('padding-right')) ) + parseInt($(trigger).css('padding-left')) + parseInt($(trigger).css('padding-right')) ) + 'px' );
      
      $(inner).css({
        'width': Math.round( ($(optionsList).width() - parseInt($(labelEx).css('padding-left')) - parseInt($(labelEx).css('padding-right')) ) + parseInt($(trigger).css('padding-left')) + parseInt($(trigger).css('padding-right')) ) + 'px'
      });
      
      $(optionsList).css({
        width: '100%'
      });

      new ScrollableContainer(optionsList, {
        scrollType: 'vertical'
      });

      /**
        Event handlers
      */
      const handleTriggerKeypresses = function (e) {
        switch(e.key) {
          case 'ArrowUp':
            e.preventDefault();
            
            if(isExpanded) {
              selectPreviousOption();
            } else {
              expandOptions();
            }
            
            break;
            
          case 'ArrowDown':
            e.preventDefault();
            
            if(isExpanded) {
              selectNextOption();
            } else {
              expandOptions();
              selectFirstOption();
            }
            
            break;
            
          case 'Home':
            if(isExpanded) {
              selectFirstOption();
            }
            
            break;
            
          case 'End':
            if(isExpanded) {
              selectLastOption();
            }
            
            break;
            
          case 'Tab':
            collapseOptions();
            break;
            
          case 'Escape':
          case 'Enter':
            if(isExpanded) {
              e.preventDefault();
              collapseOptions();
              if ( e.target.closest('[aria-modal="true"]') !== null ) {
                e.stopPropagation();
              }
            }
            
            break;
        }
      }

      const handleBodyClick = function (e) {
        if(!container.contains(e.target) && isExpanded) {
          collapseOptions();
        }
      }

      const handleTriggerClick = function () {
        if(isExpanded) {
          collapseOptions();
          trigger.focus();
        } else {
          expandOptions();
        }
      }


      /**
        Show/hide option list
      */
      const collapseOptions = function () {
        trigger.setAttribute('aria-expanded', false);
        optionsList.classList.remove('is-visible');
        isExpanded = false;
      }

      const expandOptions = function () {
        trigger.setAttribute('aria-expanded', true);
        optionsList.classList.add('is-visible');
        isExpanded = true;
      }


      /**
        Option selection
      */
      const selectFirstOption = function () {
        var firstOption = options[0];
        selectOption(firstOption);
      }

      const selectLastOption = function () {
        var lastOption = options[options.length-1];
        selectOption(lastOption);
      }

      const selectNextOption = function () {
        var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
        
        if(currentOption !== undefined) {
          var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
          
          if(currentOptionIndex + 1 < options.length) {
            var nextOption = options[currentOptionIndex + 1];
            selectOption(nextOption);
          }
        }
      }

      const selectPreviousOption = function () {
        var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
        
        if(currentOption !== undefined) {
          var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
          
          if(currentOptionIndex - 1 >= 0) {
            var previousOption = options[currentOptionIndex - 1];
            selectOption(previousOption);
          }
        }
      }

      const selectOption = function (option) {
        unselectAllOptions();
        option.setAttribute('aria-selected', true);
        trigger.setAttribute('aria-activedescendant', option.getAttribute('id'));
        selectedText.innerHTML = option.innerHTML;
        
        // Scroll item into view
        
        
        // Update the hidden field
        hiddenField.value = $(option).data('value');
        $(hiddenField).trigger('change');
      }

      const unselectAllOptions = function () {  
        options.forEach(function(option) {
          option.removeAttribute('aria-selected');
        });
      }

      // Handle keyboard and mouse interactions on the trigger bar
      trigger.addEventListener('keydown', handleTriggerKeypresses);
      trigger.addEventListener('click', handleTriggerClick);
      
      // Select options when they are clicked
      options.forEach(function(option) {
        option.addEventListener('click', function(e) {
          unselectAllOptions();
          selectOption(e.target);
          collapseOptions();
          trigger.focus();
        });
      });
      
      // Collapse the dropdown when the user clicks off
      document.addEventListener('click', handleBodyClick);
    });
  }

  if (matchMedia('(pointer:fine)').matches) {
    // Device has a mouse
    const span = document.createElement('span');
    span.classList.add('document-cursor');
    document.querySelector('body').appendChild(span);
    const transformerX = gsap.quickSetter(span, 'x', 'px');
    const transformerY = gsap.quickSetter(span, 'y', 'px');
    
    const mouseProxy = {
      x: 0,
      y: 0
    };
    
    const mouseSmoothProxy = {
      x: 0,
      y: 0
    }
    
    let accentSetters = [
      
    ];

    gsap.set(span, {
      scale: 0
    });
    
    $(window).on('mousemove', function(e){
      mouseProxy.x = event.clientX;
      mouseProxy.y = event.clientY;
    });
    
    $('.has-white-color, .has-black-background-color').on('mouseenter', function(){
      span.classList.add('on-dark');
    });
    
    $('.has-white-color, .has-black-background-color').on('mouseleave', function(){
      span.classList.remove('on-dark');
    });

    $('.has-yellow-background-color').on('mouseenter', function(){
      span.classList.add('on-yellow');
    });
    
    $('.has-yellow-background-color').on('mouseleave', function(){
      span.classList.remove('on-yellow');
    });

    $('.has-light-gray-background-color').on('mouseenter', function(){
      span.classList.add('on-light-gray');
    });
    
    $('.has-light-gray-background-color').on('mouseleave', function(){
      span.classList.remove('on-light-gray');
    });
    
    let origText = '';

    let triggers = '.wp-block-button__link, .hover-links-inner a, .logo-garden__list-item a, .content-card__title a, .cursor-trigger';
    
    $('*').on('mouseenter', triggers, function() {
      gsap.to(span, {
        scale: 1,
        duration: 0.4,
        ease: 'power4.inOut',
        overwrite: true
      });
    }).on('mouseleave', function(){
      gsap.to(span, {
        scale: 0,
        duration: 0.4,
        ease: 'power4.inOut',
        overwrite: true
      })
    });
    
    gsap.ticker.add(function(){
      transformerX(mouseProxy.x);
      transformerY(mouseProxy.y);
    });
  }

  /* Scroll animations */
  // split text elements regardless of motion query, but only animate if user has not indicated a preference for reduced motion
  const splitTextElements = document.querySelectorAll('.has-hero-font-size, h1.wp-block-heading, h2.wp-block-heading, h3.wp-block-heading, .has-h-1-font-size, .has-h-2-font-size, .has-h-3-font-size');
  splitTextElements.forEach(function(el){
    if ( el.classList.contains('dont-animate') || el.classList.contains('has-h-4-font-size') || el.classList.contains('has-h-5-font-size') || el.classList.contains('has-h-6-font-size') || el.classList.contains('has-p-font-size') ) {
      return;
    }

    el.classList.add('already-animated');

    if ( !motionQuery.matches ) {
      gsap.set(el, {
        opacity: 0
      });
    }

    const target = el.querySelector('a') || el;
    const isHero = el.nodeName.toLowerCase() === 'h1' || el.closest('.header-hero') !== null;

    SplitText.create(target, {
      type: isHero ? 'lines,words' : 'lines',
      autoSplit: true,
      mask: 'lines',
      deepSlice: true,
      linesClass: 'split-line',
      onSplit: function(self) {
        el.classList.add('split-done');
        if ( !motionQuery.matches ) {
          gsap.set(el, {
            opacity: 1
          });

          gsap.set(isHero ? self.words : self.lines, {
            y: '100%',
            opacity: 0
          });

          gsap.to(isHero ? self.words : self.lines, {
            y: '0%',
            opacity: 1,
            duration: 0.85,
            ease: 'expo.inOut',
            stagger: isHero ? {
              amount: 0.6
            } : 0.08,
            scrollTrigger: {
            trigger: el,
            start: 'top bottom',
            end: 'bottom top',
            toggleActions: 'play none none reset'
            }
          })
        }
      },
      onRevert: function() {
        el.classList.remove('split-done');
      }
    })
  });

  if ( !motionQuery.matches ) {
    const parallaxElements = document.querySelectorAll('.is-style-parallax, .is-style-page-header');
    parallaxElements.forEach(function(el){
      const target = el.querySelector('img, .wp-block-embed__wrapper, .plyr');
      if ( target ) {
        el.classList.add('already-animated');
        
        gsap.set(el, {
          overflow: 'clip'
        });

        gsap.set(target, {
          scale: 1.05,
          y: '-5%'
        });

        gsap.to(target, {
          y: '5%',
          ease: 'none',
          scrollTrigger: {
            trigger: el,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true
          }
        });
      }
    });

    const columnElements = document.querySelectorAll('.wp-block-columns.is-layout-flex, .wp-block-image, .wp-block-buttons');
    columnElements.forEach(function(el){
      if ( el.classList.contains('dont-animate') || el.classList.contains('already-animated') || el.closest('.slideshow-slide') ) {
        return;
      }

      el.classList.add('already-animated');

      const columns = el.querySelectorAll(':scope > .wp-block-column, :scope > img, :scope > picture, :scope > .wp-block-button');

      columns.forEach(function(column){
        column.classList.add('already-animated');
      });

      gsap.set(columns, {
        y: 32,
        opacity: 0
      });

      gsap.to(columns, {
        y: '0%',
        opacity: 1,
        duration: 0.85,
        ease: 'power3.inOut',
        stagger: 0.25,
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          end: 'bottom top',
          toggleActions: 'play none none reset'
        }
      });
    });

    const gridLists = document.querySelectorAll('.article-card-container, .logo-garden');
    gridLists.forEach(function(el){
      const gridItems = el.querySelectorAll('.content-card, .logo-garden__list-item');
      const columns = el.hasAttribute('data-columns') ? parseInt(el.getAttribute('data-columns')) : ( el.closest('[data-columns]') ? parseInt(el.closest('[data-columns]').getAttribute('data-columns')) : 3 );
      const mobileColumns = el.classList.contains('logo-garden') ? 3 : (el.classList.contains('is-type-team') ? 2 : 1);

      el.classList.add('already-animated');
      gridItems.forEach(function(item){
        item.classList.add('already-animated');
      });

      gsap.set(gridItems, {
        y: 32,
        opacity: 0
      });

      ScrollTrigger.batch(gridItems, {
        start: 'top bottom',
        end: 'bottom top',
        interval: 0.05,
        batchMax: () => {
          return isMobile ? mobileColumns : columns;
        },
        onEnter: batch => gsap.to(batch, {
          y: '0%',
          opacity: 1,
          duration: 0.85,
          ease: 'power3.inOut',
          stagger: {
            grid: 'auto',
            each: 0.15
          },
          overwrite: true,
          onComplete: () => {
            gsap.set(batch, {
              clearProps: 'all'
            });
          }
        }),
        onLeaveBack: batch => gsap.set(batch, {
          y: '10%',
          opacity: 0
        })
      })
    });

    const basicFadeElements = document.querySelectorAll('.is-style-fade-in, .site-main p, .site-main h4, .site-main h5, .site-main h6, .has-h-4-font-size, .has-h-5-font-size, .has-h-6-font-size, .has-p-font-size, .has-small-font-size, .site-main :where(ul,ol):not(.dont-animate) li');
    basicFadeElements.forEach(function(el){
      if ( el.classList.contains('dont-animate') || el.classList.contains('already-animated') ) {
        return;
      }

      gsap.set(el, {
        y: 32,
        opacity: 0
      });

      gsap.to(el, {
        y: 0,
        opacity: 1,
        duration: 0.85,
        ease: 'power3.inOut',
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          end: 'bottom top',
          toggleActions: 'play none none reset'
        }
      });
    });
  }
}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function(){
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  let oldState = isMobile;
  let oldNavState = isMobileNavigationActive;
  isMobile = ( windowWidth <= mobileBreakpoint );
  isMobileNavigationActive = ( windowWidth <= navBreakpoint );
  if ( windowResizeActions.length > 0 ) {
    const updated = oldState != isMobile;
    const navUpdated = oldNavState != isMobileNavigationActive;
    for (var i = 0; i < windowResizeActions.length; i++) {
      windowResizeActions[i](updated, navUpdated);
    }
  }
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions

class ScrollableContainer {
  constructor(scrollableNode, args = {}) {
    const {
      scrollType,
      scrollPadding = 32,
      classTarget = null,
      arrows = false,
      appendArrows = null
    } = args;

    this.scroller = scrollableNode;
    this.classTarget = classTarget && classTarget instanceof HTMLElement ? classTarget : this.scroller;
    this.scrollType = scrollType && ['horizontal', 'vertical'].includes(scrollType) ? scrollType : 'vertical';
    this.scrollPadding = typeof scrollPadding === 'number' ? scrollPadding : 32;
    this.arrows = typeof arrows === 'boolean' ? arrows : false;
    this.appendArrows = appendArrows && appendArrows instanceof HTMLElement ? appendArrows : this.classTarget;

    this.assessScroll();

    $(window).on('resize', (() => {
      this.assessScroll();
    }).bind(this));

    ScrollTrigger.create({
      scroller: this.scroller,
      horizontal: this.scrollType === 'horizontal',
      start: this.scrollPadding * -1,
      end: (() => {
        return this.scrollType === 'horizontal' ? this.scroller.scrollWidth - this.scroller.clientWidth : this.scroller.scrollHeight - this.scroller.clientHeight;
      }).bind(this),
      // markers: true,
      toggleClass: {
        targets: this.classTarget,
        className: 'can-scroll-positive'
      }
    })

    ScrollTrigger.create({
      scroller: this.scroller,
      horizontal: this.scrollType === 'horizontal',
      start: this.scrollPadding,
      end: (() => {
        return this.scrollType === 'horizontal' ? this.scroller.scrollWidth - this.scroller.clientWidth + this.scrollPadding : this.scroller.scrollHeight - this.scroller.clientHeight + this.scrollPadding;
      }).bind(this),
      // markers: true,
      toggleClass: {
        targets: this.classTarget,
        className: 'can-scroll-negative'
      }
    })

    if ( this.arrows !== null && this.arrows !== false ) {
      this.appendArrows.insertAdjacentHTML('afterbegin', prevArrow);
      this.appendArrows.insertAdjacentHTML('beforeend', nextArrow);

      this.nextArrow = this.appendArrows.querySelector('.slick-next');
      this.prevArrow = this.appendArrows.querySelector('.slick-prev');
      
      this.nextArrow.addEventListener('click', (e) => {
        e.preventDefault();
        const scrollAmount = this.scrollType === 'horizontal' ? this.scroller.clientWidth - this.scrollPadding : this.scroller.clientHeight - this.scrollPadding;
        if ( this.scrollType === 'horizontal' ) {
          gsap.to(this.scroller, {
            scrollTo: {
              x: this.scroller.scrollLeft + scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        } else {
          gsap.to(this.scroller, {
            scrollTo: {
              y: this.scroller.scrollTop + scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        }
      });

      this.prevArrow.addEventListener('click', (e) => {
        e.preventDefault();
        const scrollAmount = this.scrollType === 'horizontal' ? this.scroller.clientWidth - this.scrollPadding : this.scroller.clientHeight - this.scrollPadding;
        if ( this.scrollType === 'horizontal' ) {
          gsap.to(this.scroller, {
            scrollTo: {
              x: this.scroller.scrollLeft - scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        } else {
          gsap.to(this.scroller, {
            scrollTo: {
              y: this.scroller.scrollTop - scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        }
      });
    }
  }

  assessScroll() {
    this.isScrollable = this.scrollType === 'horizontal' ? this.scroller.scrollWidth > this.scroller.clientWidth : this.scroller.scrollHeight > this.scroller.clientHeight;
    console.log( this.scroller.scrollHeight, this.scroller.clientHeight, this.isScrollable );

    if ( this.isScrollable ) {
      this.classTarget.classList.add('is-scrollable');
    } else {
      this.classTarget.classList.remove('is-scrollable');
    }
  }
}